import * as S from "./BodyText.style";

const BodyText = ({ children, ...props }) => {
  return <S.TextLight {...props}>{children}</S.TextLight>;
};

export default BodyText;
